export const redLandMap = {
    "Object": {
        "1": {
            "Id": 1,
            "Name": "Chu Đề",
            "Country": 1,
            "CityType": 4,
            "RoundCity": [
                27,
                35
            ]
        },
        "3": {
            "Id": 3,
            "Name": "Bắc Bình",
            "Country": 3,
            "CityType": 4,
            "RoundCity": [
                80,
                4
            ]
        },
        "4": {
            "Id": 4,
            "Name": "Bộc Dương",
            "Country": 3,
            "CityType": 4,
            "RoundCity": [
                3,
                9,
                53,
                80
            ]
        },
        "6": {
            "Id": 6,
            "Name": "Hứa Xương",
            "Country": 3,
            "CityType": 4,
            "RoundCity": [
                10,
                58
            ]
        },
        "7": {
            "Id": 7,
            "Name": "Thành Nội",
            "Country": 3,
            "CityType": 4,
            "RoundCity": [
                72,
                15,
                14
            ]
        },
        "8": {
            "Id": 8,
            "Name": "Trần Lưu",
            "Country": 3,
            "CityType": 4,
            "RoundCity": [
                9,
                53
            ]
        },
        "9": {
            "Id": 9,
            "Name": "Nghiệp Thành",
            "Country": 3,
            "CityType": 3,
            "RoundCity": [
                14,
                8,
                4
            ]
        },
        "10": {
            "Id": 10,
            "Name": "Lạc Dương",
            "Country": 3,
            "CityType": 3,
            "RoundCity": [
                72,
                69,
                6,
                57
            ]
        },
        "11": {
            "Id": 11,
            "Name": "Trường An",
            "Country": 3,
            "CityType": 3,
            "RoundCity": [
                15,
                16
            ]
        },
        "12": {
            "Id": 12,
            "Name": "Bắc Hải",
            "Country": 3,
            "CityType": 3,
            "RoundCity": [
                80,
                77
            ]
        },
        "13": {
            "Id": 13,
            "Name": "Bành Thành",
            "Country": 2,
            "CityType": 4,
            "RoundCity": [
                50,
                58
            ]
        },
        "14": {
            "Id": 14,
            "Name": "Tấn Dương",
            "Country": 3,
            "CityType": 4,
            "RoundCity": [
                9,
                15,
                7
            ]
        },
        "15": {
            "Id": 15,
            "Name": "Bắc Địa",
            "Country": 3,
            "CityType": 4,
            "RoundCity": [
                14,
                11
            ]
        },
        "16": {
            "Id": 16,
            "Name": "Ngũ Trượng Nguyên",
            "Country": 3,
            "CityType": 5,
            "RoundCity": [
                66,
                11
            ]
        },
        "25": {
            "Id": 25,
            "Name": "Vũ Đô",
            "Country": 1,
            "CityType": 4,
            "RoundCity": [
                67,
                26,
                65
            ]
        },
        "26": {
            "Id": 26,
            "Name": "Tử Đồng",
            "Country": 1,
            "CityType": 4,
            "RoundCity": [
                25,
                27
            ]
        },
        "27": {
            "Id": 27,
            "Name": "Thành Đô",
            "Country": 1,
            "CityType": 3,
            "RoundCity": [
                26,
                37,
                1
            ]
        },
        "30": {
            "Id": 30,
            "Name": "Kiến Ninh",
            "Country": 1,
            "CityType": 3,
            "RoundCity": [
                35,
                78
            ]
        },
        "31": {
            "Id": 31,
            "Name": "Lang Trung",
            "Country": 1,
            "CityType": 4,
            "RoundCity": [
                65,
                61,
                37
            ]
        },
        "33": {
            "Id": 33,
            "Name": "Vĩnh An",
            "Country": 1,
            "CityType": 4,
            "RoundCity": [
                37,
                78
            ]
        },
        "34": {
            "Id": 34,
            "Name": "Mạch Thành",
            "Country": 2,
            "CityType": 4,
            "RoundCity": [
                78,
                38,
                74
            ]
        },
        "35": {
            "Id": 35,
            "Name": "Vân Nam",
            "Country": 1,
            "CityType": 4,
            "RoundCity": [
                1,
                30
            ]
        },
        "37": {
            "Id": 37,
            "Name": "Giang Châu",
            "Country": 1,
            "CityType": 4,
            "RoundCity": [
                27,
                33,
                31
            ]
        },
        "38": {
            "Id": 38,
            "Name": "Giang Lăng",
            "Country": 2,
            "CityType": 4,
            "RoundCity": [
                79,
                34
            ]
        },
        "39": {
            "Id": 39,
            "Name": "Tương Dương",
            "Country": 2,
            "CityType": 4,
            "RoundCity": [
                79,
                45
            ]
        },
        "40": {
            "Id": 40,
            "Name": "Phượng Tường",
            "Country": 2,
            "CityType": 3,
            "RoundCity": [
                74,
                62,
                41
            ]
        },
        "41": {
            "Id": 41,
            "Name": "Dự Chương",
            "Country": 2,
            "CityType": 4,
            "RoundCity": [
                40,
                47
            ]
        },
        "43": {
            "Id": 43,
            "Name": "Sài Tang",
            "Country": 2,
            "CityType": 4,
            "RoundCity": [
                82,
                62
            ]
        },
        "45": {
            "Id": 45,
            "Name": "Tân Dã",
            "Country": 2,
            "CityType": 3,
            "RoundCity": [
                59,
                57,
                71,
                39
            ]
        },
        "47": {
            "Id": 47,
            "Name": "Kiến An",
            "Country": 2,
            "CityType": 4,
            "RoundCity": [
                41,
                49
            ]
        },
        "48": {
            "Id": 48,
            "Name": "Ngô Quận",
            "Country": 2,
            "CityType": 3,
            "RoundCity": [
                56,
                52,
                81
            ]
        },
        "49": {
            "Id": 49,
            "Name": "Kiến Nghiệp",
            "Country": 2,
            "CityType": 3,
            "RoundCity": [
                47,
                82,
                51
            ]
        },
        "50": {
            "Id": 50,
            "Name": "Từ Châu",
            "Country": 2,
            "CityType": 4,
            "RoundCity": [
                56,
                77,
                13
            ]
        },
        "51": {
            "Id": 51,
            "Name": "Lâm Hải",
            "Country": 2,
            "CityType": 4,
            "RoundCity": [
                49,
                52,
                82
            ]
        },
        "52": {
            "Id": 52,
            "Name": "Cối Kê",
            "Country": 2,
            "CityType": 4,
            "RoundCity": [
                48,
                51
            ]
        },
        "53": {
            "Id": 53,
            "Name": "Quan Độ",
            "Country": 3,
            "CityType": 4,
            "RoundCity": [
                4,
                8
            ]
        },
        "56": {
            "Id": 56,
            "Name": "Quảng Lăng",
            "Country": 2,
            "CityType": 5,
            "RoundCity": [
                50,
                48
            ]
        },
        "57": {
            "Id": 57,
            "Name": "Uyển Thành",
            "Country": 3,
            "CityType": 4,
            "RoundCity": [
                10,
                58,
                45
            ]
        },
        "58": {
            "Id": 58,
            "Name": "Nhữ Nam",
            "Country": 3,
            "CityType": 5,
            "RoundCity": [
                13,
                6,
                57
            ]
        },
        "59": {
            "Id": 59,
            "Name": "Thượng Dung",
            "Country": 1,
            "CityType": 4,
            "RoundCity": [
                60,
                45,
                79
            ]
        },
        "60": {
            "Id": 60,
            "Name": "Hán Trung",
            "Country": 1,
            "CityType": 3,
            "RoundCity": [
                69,
                68,
                61,
                59
            ]
        },
        "61": {
            "Id": 61,
            "Name": "Hà Manh",
            "Country": 1,
            "CityType": 5,
            "RoundCity": [
                31,
                60
            ]
        },
        "62": {
            "Id": 62,
            "Name": "Xích Bích",
            "Country": 2,
            "CityType": 4,
            "RoundCity": [
                71,
                40,
                43
            ]
        },
        "65": {
            "Id": 65,
            "Name": "Kỳ Sơn",
            "Country": 1,
            "CityType": 4,
            "RoundCity": [
                25,
                31
            ]
        },
        "66": {
            "Id": 66,
            "Name": "Nhai Đình",
            "Country": 3,
            "CityType": 4,
            "RoundCity": [
                16,
                76,
                70
            ]
        },
        "67": {
            "Id": 67,
            "Name": "Thiên Thủy",
            "Country": 1,
            "CityType": 3,
            "RoundCity": [
                76,
                25
            ]
        },
        "68": {
            "Id": 68,
            "Name": "Phù Phong",
            "Country": 1,
            "CityType": 4,
            "RoundCity": [
                75,
                60
            ]
        },
        "69": {
            "Id": 69,
            "Name": "Hoằng Nông",
            "Country": 3,
            "CityType": 4,
            "RoundCity": [
                75,
                10,
                60
            ]
        },
        "70": {
            "Id": 70,
            "Name": "Trần Thương",
            "Country": 3,
            "CityType": 4,
            "RoundCity": [
                75,
                66
            ]
        },
        "71": {
            "Id": 71,
            "Name": "Trường Bản",
            "Country": 2,
            "CityType": 5,
            "RoundCity": [
                45,
                62,
                81
            ]
        },
        "72": {
            "Id": 72,
            "Name": "Ải Hổ Lao",
            "Country": 3,
            "CityType": 5,
            "RoundCity": [
                7,
                10
            ]
        },
        "73": {
            "Id": 73,
            "Name": "Mỏ Khoáng Chung",
            "Country": 0,
            "CityType": 1,
            "RoundCity": []
        },
        "74": {
            "Id": 74,
            "Name": "Hoa Cốc Đạo",
            "Country": 2,
            "CityType": 5,
            "RoundCity": [
                34,
                40
            ]
        },
        "75": {
            "Id": 75,
            "Name": "Đồng Quan",
            "Country": 3,
            "CityType": 5,
            "RoundCity": [
                70,
                69,
                68
            ]
        },
        "76": {
            "Id": 76,
            "Name": "Dương Bình Quan",
            "Country": 1,
            "CityType": 5,
            "RoundCity": [
                66,
                67
            ]
        },
        "77": {
            "Id": 77,
            "Name": "Hạ Phi",
            "Country": 3,
            "CityType": 5,
            "RoundCity": [
                12,
                50
            ]
        },
        "78": {
            "Id": 78,
            "Name": "Di Lăng",
            "Country": 1,
            "CityType": 5,
            "RoundCity": [
                33,
                30,
                34
            ]
        },
        "79": {
            "Id": 79,
            "Name": "Đàn Khê",
            "Country": 1,
            "CityType": 5,
            "RoundCity": [
                59,
                39,
                38
            ]
        },
        "80": {
            "Id": 80,
            "Name": "Nam Bì",
            "Country": 3,
            "CityType": 4,
            "RoundCity": [
                3,
                12,
                4
            ]
        },
        "81": {
            "Id": 81,
            "Name": "Thọ Xuân",
            "Country": 2,
            "CityType": 4,
            "RoundCity": [
                48,
                71,
                82
            ]
        },
        "82": {
            "Id": 82,
            "Name": "Lư Giang",
            "Country": 2,
            "CityType": 4,
            "RoundCity": [
                81,
                51,
                49,
                43
            ]
        },
        "83": {
            "Id": 83,
            "Name": "Võ Khôi Tháp",
            "Country": 0,
            "CityType": 6
        },
        "84": {
            "Id": 84,
            "Name": "Loạn Tôn Viện lv220",
            "Country": 0,
            "CityType": 7
        }
    }
}